import React from "react";
import { usePdpProduct } from "@/features/pdp/PdpContext";
import { ThumbnailButton } from "./ThumbnailButton";

export interface ThumbnailGroupProps {
  selectedIndex: number;
  onThumbnailClick: (ind: number) => void;
}

export const ThumbnailGroup = ({
  selectedIndex,
  onThumbnailClick,
}: ThumbnailGroupProps) => {
  const product = usePdpProduct();
  if (product.media.length <= 1) {
    return null;
  }
  return (
    <div
      className="relative z-10 mx-2 flex flex-col"
      role="radiogroup"
      aria-label="Thumbnail images"
    >
      {product.media.map((item, index) => (
        <ThumbnailButton
          key={item.url}
          onClick={() => onThumbnailClick(index)}
          alt={`Thumbnail (${index + 1})`}
          selected={index == selectedIndex}
          thumbnailSrc={item.url}
          mediaType={item.mediaType}
        />
      ))}
    </div>
  );
};
